/** A pele de cada hub nas telas de entrada: logo, foto do hero, marcas no canto do
 *  hero, exemplo do e-mail e empresa do rodapé. As cores moram no `login.css`, em
 *  `.login-stage[data-hub]`.
 *
 *  A pele do HubVerticalFarm usa o verde da Agri8 com títulos em preto, escolha de 28/10/2026. */
import type { MessageKey } from '@/core/i18n/messages'
import type { HubKey } from '@/core/hubs/hubs'

/** Marca da empresa no canto do hero, sempre em branco. A classe dá a altura. */
export interface MarcaDoHero {
  src: string
  alt: string
  classe: string
}

export interface PeleDoHub {
  logo: string
  /** Logo do painel escuro. Sem ele, o CSS clareia o logo claro. */
  logoEscuro?: string
  heroFoto: string
  heroAltKey: MessageKey
  marcasDoHero: MarcaDoHero[]
  emailPlaceholderKey: MessageKey
  empresa: string
}

export const PELES: Record<HubKey, PeleDoHub> = {
  transgraos: {
    logo: '/assets/logo-hubtransgraos.webp',
    heroFoto: '/assets/breakout-truck.webp',
    heroAltKey: 'auth.loginPage.heroAlt',
    marcasDoHero: [{ src: '/assets/logo-transgraos.svg', alt: 'TransGrãos', classe: 'login-hero-marca-transgraos' }],
    emailPlaceholderKey: 'auth.loginPage.emailPlaceholder',
    empresa: 'TransGrãos LTDA',
  },
  farm: {
    logo: '/assets/logo-hubverticalfarm.svg',
    logoEscuro: '/assets/logo-hubverticalfarm-escuro.svg',
    heroFoto: '/assets/breakout-lavoura.webp',
    heroAltKey: 'auth.loginPage.heroAltFarm',
    marcasDoHero: [
      { src: '/assets/logo-agri8.svg', alt: 'Agri8', classe: 'login-hero-marca-agri8' },
      { src: '/assets/logo-segredo.svg', alt: 'Segredo', classe: 'login-hero-marca-segredo' },
      {
        src: '/assets/logo-segredo-agroflorestal.svg',
        alt: 'Segredo Agroflorestal',
        classe: 'login-hero-marca-segredo-agroflorestal',
      },
    ],
    emailPlaceholderKey: 'auth.loginPage.emailPlaceholderFarm',
    empresa: 'Vertical Investimentos',
  },
}
